<template>
  <v-sheet class="py-6 px-8">
    <p class="text-h6 font-weight-bold grey--text text--darken-3 text-center mb-6">프로모션 수정하기</p>

    <v-sheet class="mt-2 px-4">
      <v-text-field class="rounded-10" label="이름" dense outlined v-model.trim="updateItem.name"></v-text-field>
      <v-text-field class="rounded-10" label="코드" dense outlined v-model.trim="updateItem.code"></v-text-field>
      <v-text-field class="rounded-10" label="솔로샷(KRW)" dense outlined type="number" hide-spin-buttons v-model="updateItem.option1Price"></v-text-field>
      <v-text-field class="rounded-10" label="솔로샷 듀얼(KRW)" dense outlined type="number" hide-spin-buttons v-model="updateItem.option2Price"></v-text-field>
      <v-text-field class="rounded-10" label="그룹샷(KRW)" dense outlined type="number" hide-spin-buttons v-model="updateItem.option3Price"></v-text-field>
      <v-text-field class="rounded-10" label="2인할인팩(KRW)" dense outlined type="number" hide-spin-buttons v-model="updateItem.option4Price"></v-text-field>
      <v-text-field class="rounded-10" label="3인할인팩(KRW)" dense outlined type="number" hide-spin-buttons v-model="updateItem.option5Price"></v-text-field>
      <v-text-field class="rounded-10" label="4인할인팩(KRW)" dense outlined type="number" hide-spin-buttons v-model="updateItem.option6Price"></v-text-field>

      <v-select outlined dense :items="conceptList" item-text="title" item-value="id" v-model="updateItem.conceptId" label="컨셉" :key="'concept' + conceptComponentKey"></v-select>

      <div class="font-weight-bold text-body-1 py-2">프로모션 유효기간</div>
      <v-row>
        <v-menu v-model="openAtMenu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="updateItem.openAt" label="링크시작일" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" color="green"></v-text-field>
          </template>
          <v-date-picker v-model="updateItem.openAt" no-title scrollable color="green" @input="openAtMenu = false"></v-date-picker>
        </v-menu>
        <v-menu v-model="closeAtMenu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="updateItem.closeAt" label="링크종료일" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" color="warning"></v-text-field>
          </template>
          <v-date-picker v-model="updateItem.closeAt" no-title scrollable color="warning" @input="closeAtMenu = false"> </v-date-picker>
        </v-menu>
      </v-row>

      <div class="font-weight-bold text-body-1 py-2">예약 가능 기간</div>
      <v-row>
        <v-menu v-model="startAtMenu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="updateItem.startAt" label="예약 시작일자" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" color="green"></v-text-field>
          </template>
          <v-date-picker v-model="updateItem.startAt" no-title scrollable color="green" @input="startAtMenu = false"> </v-date-picker>
        </v-menu>
        <v-menu v-model="endAtMenu" :close-on-content-click="false" transition="scale-transition" offset-y min-width="auto">
          <template v-slot:activator="{ on, attrs }">
            <v-text-field v-model="updateItem.endAt" label="예약 종료일자" prepend-icon="mdi-calendar" readonly v-bind="attrs" v-on="on" color="warning"></v-text-field>
          </template>
          <v-date-picker v-model="updateItem.endAt" no-title scrollable color="warning" @input="endAtMenu = false"> </v-date-picker>
        </v-menu>
      </v-row>

      <div class="d-inline-block">
        <v-checkbox v-model="updateItem.enabled" class="shrink mt-4 ml-4" label="활성화 상태" color="primary" hide-details dense></v-checkbox>
      </div>

      

      <div class="font-weight-bold text-h6 ml-4 mt-4">한글</div>
      <v-sheet class="mt-2">
        <div class="d-flex justify-space-between">
          <span class="grey--text text-body-2">필요한 상품에 대한 설명을 입력해 주세요</span>
          <v-btn color="primary" depressed outlined small @click="clear()">삭제</v-btn>
        </div>
        <!-- 설명 -->
        <TipTapWriter class="tiptap_style mt-2" :options="options" :key="componentKey" />
      </v-sheet>

      <div class="font-weight-bold text-h6 ml-4 mt-4">영어</div>
      <v-sheet class="mt-2">
        <div class="d-flex justify-space-between">
          <span class="grey--text text-body-2">필요한 상품에 대한 설명을 입력해 주세요</span>
          <v-btn color="primary" depressed outlined small @click="clear('en')">삭제</v-btn>
        </div>
        <!-- 설명 -->
        <TipTapWriter class="tiptap_style mt-2" :options="en.options" :key="'en-desc1' + en.componentKey" />
      </v-sheet>

      <div class="font-weight-bold text-h6 ml-4 mt-4">일본어</div>
      <v-sheet class="mt-2">
        <div class="d-flex justify-space-between">
          <span class="grey--text text-body-2">필요한 상품에 대한 설명을 입력해 주세요</span>
          <v-btn color="primary" depressed outlined small @click="clear('jp')">삭제</v-btn>
        </div>
        <!-- 설명 -->
        <TipTapWriter class="tiptap_style mt-2" :options="jp.options" :key="'jp-desc1' + jp.componentKey" />
      </v-sheet>


      <div class="d-inline-block">
        <v-checkbox v-model="updateItem.isIndividual" class="shrink mt-4 ml-4" label="개별 운영 (디아블린)" color="primary" hide-details dense></v-checkbox>
      </div>

      <!-- 개별 운영시간 설정 -->
      <v-sheet v-if="updateItem.isIndividual" class="mt-4 pa-4" outlined>
        <div class="font-weight-bold text-h6 mb-4">개별 운영시간 설정</div>
        <div v-for="(item, index) in dayItems" :key="item" class="mb-4">
          <div class="font-weight-bold mb-2">{{ item }}</div>
          <WeekTimeComponent :key="'week-time' + index + componentKey" @change="(v) => setOperationTime(index, v)" :src="operationSettings[index]" />
        </div>
      </v-sheet>

    </v-sheet>
    <v-sheet class="d-flex justify-center mt-5">
      <v-btn class="rounded-10 px-6 mr-4" color="grey" large dark depressed @click="$emit('close')">
        <v-icon small left>mdi-cancel</v-icon>
        취소하기
      </v-btn>
      <v-btn class="rounded-10 px-6" color="primary" large dark depressed @click="updateSubmit()">
        <v-icon small left>mdi-database-edit-outline</v-icon>
        수정하기
      </v-btn>
    </v-sheet>
  </v-sheet>
</template>
<script>
import TipTapWriter from "@/components/tiptap/Writer"
import WeekTimeComponent from "@/views/admin/operation_time/WeekTimeComponent"

import { mapState } from "vuex"

export default {
  props: ["updateItem_import"],
  components: {
    TipTapWriter,
    WeekTimeComponent,
  },
  inject: ["coupons_info", "concepts"],
  data: () => ({
    yesOrNo: ["Y", "N"],
    updateItem: {},

    startAtMenu: false,
    endAtMenu: false,
    openAtMenu: false,
    closeAtMenu: false,

    conceptList: [
      {
        title: "선택안함",
        id: null,
      },
    ],

    //TipTap
    options: {
      content: "",
      editable: true,
      supportImage: true,
      supportVideo: true,
    },
    componentKey: 0,

    en: {
      //TipTap
      options: {
        content: "",
        editable: true,
        supportImage: true,
        supportVideo: true,
      },
      componentKey: 0,
    },
    jp: {
      //TipTap
      options: {
        content: "",
        editable: true,
        supportImage: true,
        supportVideo: true,
      },
      componentKey: 0,
    },
    conceptComponentKey: 0,

    // 개별 운영시간 설정
    dayItems: ["월", "화", "수", "목", "금", "토", "일"],
    operationSettings: [[], [], [], [], [], [], []],
    existingOperationTimeId: null,
  }),

  mounted() {
    this.conceptList.push(...this.concepts)
    this.conceptComponentKey++

    this.updateItem = {
      ...this.updateItem_import,

      openAt: this.updateItem_import.openAt ? this.dayjs(this.updateItem_import.openAt).format("YYYY-MM-DD") : null,
      closeAt: this.updateItem_import.closeAt ? this.dayjs(this.updateItem_import.closeAt).format("YYYY-MM-DD") : null,
      startAt: this.updateItem_import.startAt ? this.dayjs(this.updateItem_import.startAt).format("YYYY-MM-DD") : null,
      endAt: this.updateItem_import.endAt ? this.dayjs(this.updateItem_import.endAt).format("YYYY-MM-DD") : null,
    }
    this.options.content = this.updateItem.content
    this.en.options.content = this.updateItem.content_en
    this.jp.options.content = this.updateItem.content_jp

    this.componentKey++
    this.en.componentKey++
    this.jp.componentKey++

    // 개별 운영시간 정보 로드
    if (this.updateItem.isIndividual) {
      this.loadOperationTime()
    }

    console.log(this.updateItem)
  },

  methods: {
    clear(lang = "ko") {
      if (lang === "ko") {
        this.options.content = ""
        this.componentKey++
      } else if (lang === "en") {
        this.en.options.content = ""
        this.en.componentKey++
      } else if (lang === "jp") {
        this.jp.options.content = ""
        this.jp.componentKey++
      }
    },

    setOperationTime(index, value) {
      this.operationSettings[index] = value
    },

    async loadOperationTime() {
      try {
        const res = await this.$http.get(`/api/individual_operation_time/select/promotionCode`, {
          params: {
            promotionCode: this.updateItem.code,
          },
        })
        if (res.data && res.data.length > 0) {
          const info = res.data[0]
          this.existingOperationTimeId = info.id
          this.operationSettings[0] = info.mon ? info.mon.split(",").map((e) => e.trim()) : []
          this.operationSettings[1] = info.tue ? info.tue.split(",").map((e) => e.trim()) : []
          this.operationSettings[2] = info.wed ? info.wed.split(",").map((e) => e.trim()) : []
          this.operationSettings[3] = info.thu ? info.thu.split(",").map((e) => e.trim()) : []
          this.operationSettings[4] = info.fri ? info.fri.split(",").map((e) => e.trim()) : []
          this.operationSettings[5] = info.sat ? info.sat.split(",").map((e) => e.trim()) : []
          this.operationSettings[6] = info.sun ? info.sun.split(",").map((e) => e.trim()) : []
          this.componentKey++
        }
      } catch (e) {
        console.log("개별 운영시간 로드 실패:", e)
      }
    },

    // 목록
    updateSubmit: _.debounce(async function () {
      // 제목 검증
      // if (this.updateItem.name == "") {
      //   alert("이름을 입력해주세요")
      //   return
      // }

      // 컨셉소개 내용 검증
      if (this.updateItem.code == "") {
        alert("프로모션 코드를 입력해주세요")
        return
      }

      // 가격 검증
      if (Number(this.updateItem.option1Price) < 0 || Number(this.updateItem.option2Price) < 0 || Number(this.updateItem.option3Price) < 0) {
        alert("유효한 가격 정보를 입력해주세요")
        return
      }

      if (!this.updateItem.endAt) {
        alert("종료일자를 입력해주세요")
        return
      }

      this.$http
        .post("/api/promotion/update", {
          params: {
            code: this.updateItem.code,
            name: this.updateItem.name,
            option1Price: Number(this.updateItem.option1Price),
            option2Price: Number(this.updateItem.option2Price),
            option3Price: Number(this.updateItem.option3Price),
            option4Price: Number(this.updateItem.option4Price),
            option5Price: Number(this.updateItem.option5Price),
            option6Price: Number(this.updateItem.option6Price),
            conceptId: this.updateItem.conceptId,
            enabled: this.updateItem.enabled,
            openAt: this.updateItem.openAt,
            closeAt: this.updateItem.closeAt,
            startAt: this.updateItem.startAt,
            endAt: this.updateItem.endAt,
            description: this.options.content,
            description_en: this.en.options.content,
            description_jp: this.jp.options.content,
            isIndividual: this.updateItem.isIndividual,
            id: this.updateItem.id,
          },
        })
        .then(async (res) => {
          if (res) {
            // 개별 운영시간 설정 처리
            if (this.updateItem.isIndividual) {
              try {
                const operationData = {
                  promotionCode: this.updateItem.code,
                  mon: this.operationSettings[0].length > 0 ? this.operationSettings[0].join(",") : "",
                  tue: this.operationSettings[1].length > 0 ? this.operationSettings[1].join(",") : "",
                  wed: this.operationSettings[2].length > 0 ? this.operationSettings[2].join(",") : "",
                  thu: this.operationSettings[3].length > 0 ? this.operationSettings[3].join(",") : "",
                  fri: this.operationSettings[4].length > 0 ? this.operationSettings[4].join(",") : "",
                  sat: this.operationSettings[5].length > 0 ? this.operationSettings[5].join(",") : "",
                  sun: this.operationSettings[6].length > 0 ? this.operationSettings[6].join(",") : "",
                }

                if (this.existingOperationTimeId) {
                  // 기존 데이터 업데이트
                  await this.$http.post("/api/individual_operation_time/update", {
                    ...operationData,
                    id: this.existingOperationTimeId,
                  })
                } else {
                  // 새로운 데이터 생성
                  await this.$http.post("/api/individual_operation_time/insert", operationData)
                }
              } catch (e) {
                console.log("개별 운영시간 저장 실패:", e)
              }
            } else if (this.existingOperationTimeId) {
              // isIndividual false로 변경된 경우 기존 데이터 삭제
              try {
                await this.$http.post("/api/individual_operation_time/delete", {
                  id: this.existingOperationTimeId,
                })
                this.existingOperationTimeId = null
              } catch (e) {
                console.log("개별 운영시간 삭제 실패:", e)
              }
            }

            alert("정상적으로 등록되었습니다.")
            this.$emit("close")
          } else {
            alert("등록되지 않았습니다")
          }
        })
        .catch((e) => {
          console.log(e)
          alert(this.$t("alert.error_page"))
        })
    }, 500),
  },
}
</script>
<style scoped>
.my-clipper {
  width: 100%;
}

.placeholder {
  width: 100%;
  height: 150px;
}
</style>
